import { useContext } from "react";
import { AppContext } from "../../contexts/AppContext";
import { Logo } from "./Logo";
import { LoadingContent } from "./Shared/LoadingContent";
import { RightHandNavLoggedOut } from "./RightHandNavLoggedOut";
import { RightHandNavLoggedIn } from "./RightHandNavLoggedIn";

export function Header() {

    const app = useContext(AppContext);

    return (
        <>
            <header className="navbar shadow navbar-expand-lg sticky-top bg-primary ah-primary-header">
                <nav className="container-xxl flex-wrap flex-lg-nowrap" aria-label="Main navigation">
                    <div>
                        <button className="navbar-toggler btn-squared btn-contrast btn-squared p-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#lhmSidebar" aria-controls="lhmSidebar" aria-label="Toggle navigation">
                            {/* LHM Mobile button */}
                            <i className="fa-solid fa-bars"></i>
                        </button>
                    </div>
                    <Logo />

                    <div className="d-flex justify-content-end">
                        <button className="navbar-toggler btn-contrast btn-squared d-flex d-lg-none order-3 p-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#rhmNavbar" aria-controls="rhmNavbar" aria-label="Toggle login and user details">
                            {/* RHM Mobile button */}
                            <LoadingContent loading={app.loading} classes="w-100">
                                <i className="fa-solid fa-bars"></i>
                            </LoadingContent>
                        </button>
                    </div>

                    <LoadingContent loading={app.loading} classes="w-100 d-none d-lg-block text-end">
                        <RightHandNavLoggedOut />
                        <RightHandNavLoggedIn />
                    </LoadingContent>

                </nav>
            </header>
        </>
    )
}